import { navigateToStep } from 'actions/onlineBooking/actions/OnlineBookingFlowActions';
import React from 'react';
import { dispatch } from 'store';
import { OnlineBookingStep } from 'types/OnlineBooking';

export const phoneAlreadyTakenMessage = (
    <>
        This phone number is already registered. Please{' '}
        <b
            className="underline cursor-pointer"
            onClick={() => dispatch(navigateToStep(OnlineBookingStep.Signin))}
        >
            log in
        </b>{' '}
        to continue.
    </>
);
